import config from '../../../../../../../../../../config'

import { SUBMIT_USER_DATA_FORM, UPDATE_USER_DATA_REQUEST, RELOAD_UPDATE_USER_DATA_REQUEST } from './constants'

export function submitDataForm(contentId, values) {
    return {
        type: SUBMIT_USER_DATA_FORM,
        data: {
            contentId,
            values,
        },
    }
}

export function updateUserDataRequest(sessionId, firstName, lastName, email) {
    return {
        type: UPDATE_USER_DATA_REQUEST,
        payload: {
            ...config.api.userProfileChange,
            formData: `first_name=${encodeURIComponent(firstName)}&last_name=${encodeURIComponent(
                lastName
            )}&email=${encodeURIComponent(email)}`,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                sid: sessionId,
                Accept: 'text/html',
            },
        },
    }
}

export function reloadUserInfoRequest(sessionId) {
    return {
        type: RELOAD_UPDATE_USER_DATA_REQUEST,
        payload: {
            ...config.api.userInfo,
            headers: {
                sid: `gnosus/${sessionId}`,
            },
            qs: {
                sid: sessionId,
            },
        },
    }
}
